var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#D32F2F",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1852 12L15.7568 9.42837C16.0811 9.10412 16.0811 8.56744 15.7568 8.24319C15.4326 7.91894 14.8959 7.91894 14.5716 8.24319L12 10.8148L9.42837 8.24319C9.10412 7.91894 8.56744 7.91894 8.24319 8.24319C7.91894 8.56744 7.91894 9.10412 8.24319 9.42837L10.8148 12L8.24319 14.5716C7.91894 14.8959 7.91894 15.4326 8.24319 15.7568C8.4109 15.9245 8.62334 16.0028 8.83578 16.0028C9.04822 16.0028 9.26066 15.9245 9.42837 15.7568L12 13.1852L14.5716 15.7568C14.7393 15.9245 14.9518 16.0028 15.1642 16.0028C15.3767 16.0028 15.5891 15.9245 15.7568 15.7568C16.0811 15.4326 16.0811 14.8959 15.7568 14.5716L13.1852 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX6);
export default __webpack_public_path__ + "static/media/x6.cfa6d0502f1f962ee4af13672f5006df.svg";
export { ForwardRef as ReactComponent };